import { render, staticRenderFns } from "./NotificationAddExtraDoc.vue?vue&type=template&id=49f4e6cc"
import script from "./NotificationAddExtraDoc.vue?vue&type=script&lang=js"
export * from "./NotificationAddExtraDoc.vue?vue&type=script&lang=js"
import style0 from "./NotificationAddExtraDoc.vue?vue&type=style&index=0&id=49f4e6cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports